import React, { PropsWithChildren, forwardRef } from 'react'
import styled from 'styled-components'
import BaseDropdownSheet, { DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE, DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE, DROPDOWN_SHEET_MIN_HEIGHT_CSS_VARIABLE, DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE, DROPDOWN_SHEET_WIDTH_CSS_VARIABLE } from '../BaseDropdownSheet'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled(BaseDropdownSheet)`
  ${DROPDOWN_SHEET_MIN_HEIGHT_CSS_VARIABLE}: ${rem(200)};
  ${DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE}: ${rem(480)};
  ${DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE}: ${rem(200)};
  ${DROPDOWN_SHEET_WIDTH_CSS_VARIABLE}: 100%;
  ${DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE}: ${rem(335)};

  ${mediaQueryUp.tablet} {
    ${DROPDOWN_SHEET_MIN_HEIGHT_CSS_VARIABLE}: ${rem(200)};
    ${DROPDOWN_SHEET_MAX_HEIGHT_CSS_VARIABLE}: ${rem(584)};
    ${DROPDOWN_SHEET_MIN_WIDTH_CSS_VARIABLE}: ${rem(280)};
    ${DROPDOWN_SHEET_MAX_WIDTH_CSS_VARIABLE}: ${rem(1140)};
  }
`

const DropdownListSheet = forwardRef<HTMLDivElement, PropsWithChildren>((props, ref) => {
  const {
    children,
  } = props

  return <Container ref={ref}>
    {children}
  </Container>
})

export default DropdownListSheet
